import * as React from 'react';
import { type HeadFC } from 'gatsby';
import { HomePage } from '../app/homePage/HomePage';
import { OnePagerPage } from '@/app/onePagerPage/OnePagerPage';
import { SEO } from '@/ui/components/seo/SEO';

const IndexPage = () => {
  if (process.env.GATSBY_IS_ONE_PAGER_ENABLED === 'true') {
    return <OnePagerPage />;
  }

  return <HomePage />;
};

export default IndexPage;

export const Head: HeadFC = () => (
  <SEO title="Cochran - Unmatched expertise for the most complex electrical & technology projects." />
);
